<template>
  <div>
    <div class="breakouts--container">
      <div class="breakout-rooms-form">
        <el-form :model="breakoutRooms" label-width="180px">
          <el-form-item label="Room Prefix">
            <el-col :span="4">
              <el-input
                v-model="breakoutRooms.prefix"
                type="text"
                placeholder="Add prefix"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="Topic">
            <el-col :span="10">
              <el-input
                v-model="breakoutRooms.topic"
                type="text"
                placeholder="Add topic"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="Room Limit">
            <el-col :span="4">
              <el-input
                v-model.number="breakoutRooms.limit"
                type="text"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="Number of Rooms">
            <el-col :span="6">
              <el-input-number
                :min="0"
                v-model="breakoutRooms.count"
                size="small"
                class="breakout-input-number"
              ></el-input-number>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="breakouts--footer">
      <el-button type="default" @click="handleCancel">Cancel</el-button>
      <el-button type="primary" v-on:click="createBreakoutRooms"
        >Done</el-button
      >
    </div>
  </div>
</template>

<script>
import _ from "underscore";
import axios from "../../client";
import Constants from "../Constants";
import { mapState, mapGetters } from "vuex";
import { getSocketPayload } from "../../utils";

export default {
  data: function() {
    return {
      breakoutRooms: {
        count: 1,
        prefix: "",
        limit: null,
        topic: ""
      },
      breakOutFormVisible: false
    };
  },
  methods: {
    getLastRoomRank: function() {
      const lastRoom = this.sortRooms(this.rooms).pop();
      return lastRoom.rank ? lastRoom.rank : 0;
    },

    createBreakoutRooms: function() {
      let skippedRoomCount = 0;
      const lastRoomRank = this.getLastRoomRank();
      _.range(1, this.breakoutRooms.count + 1).forEach(async roomNumber => {
        let isRoomCreated = false;
        while (!isRoomCreated) {
          const rank = roomNumber + lastRoomRank + skippedRoomCount;
          try {
            let breakoutRoomName =
              (this.breakoutRooms.prefix || this.mainRoom.name) +
              ` ${Constants.BREAKOUT_ROOM_PREFIX} ` +
              rank;
            const response = await axios.post("/api/rooms/", {
              mainRoom: this.mainRoom.name,
              name: breakoutRoomName,
              topic: this.breakoutRooms.topic,
              parent: this.mainRoom._id,
              rank: rank,
              normalRoomParticipantsLimit:
                this.breakoutRooms.limit || undefined,
              expandedRoomParticipantsLimit:
                this.breakoutRooms.limit || undefined
            });
            this.socket.emit(
              "NEW_ROOM_CREATED",
              getSocketPayload({ roomId: response.data._id })
            );
            isRoomCreated = true;
          } catch (err) {
            skippedRoomCount++;
            if (skippedRoomCount >= 100) {
              break;
            }
            if (err.response.data.message === "TOKEN_EXPIRED") {
              this.$store.dispatch(
                "user/refreshTokens",
                this.makeBreakOutRooms
              );
              return;
            }
          }
        }
      });
      this.handleDone();
    },

    handleCancel() {
      this.$emit("canceled");
    },

    handleDone() {
      this.$emit("done");
    }
  },
  computed: {
    ...mapState({
      mainRoom: state => state.rooms.mainRoom,
      rooms: state => state.rooms.rooms,
      tokens: state => state.user.tokens
    }),
    ...mapGetters("rooms", {
      socket: "getSocket",
      sortRooms: "sortRooms"
    })
  }
};
</script>

<style scoped>
.breakout-rooms {
  fill: #f7f7f7;
}

.breakout-rooms:hover {
  fill: #409eff;
}

.breakout-input-number {
  margin: 0px 10px;
}

.breakouts--container {
  width: 668px;
  padding-top: 50px;
  height: calc(599px - 71px - 50px - 76px);
}

.breakouts--container .breakout-rooms-form {
  width: 100%;
}

.el-form-item {
  border-bottom: 1px solid #393752;
  margin-bottom: 0;
  padding: 8px;
}

>>> label.el-form-item__label {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.8);
  padding: 10px 0 0 16px;
  text-align: left;
}

>>> .el-input .el-input__inner {
  padding: 6px;
  height: 34px;
}

>>> .el-input .el-input__inner::-webkit-input-placeholder {
  /* Edge */
  color: #7f7e95;
  font-family: inherit;
}

>>> .el-input .el-input__inner:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #7f7e95;
  font-family: inherit;
}

>>> .el-input .el-input__inner::placeholder {
  color: #7f7e95;
  font-family: inherit;
}

>>> .el-input__inner::placeholder {
  color: #7f7e95;
}

>>> .el-input-number__decrease,
>>> .el-input-number__increase {
  background-color: #393752;
  border: none;
}

.breakout-input-number {
  margin: 0px 10px 0 0;
}

.breakouts--footer {
  border-top: 1px solid #393752;
  padding: 32px 24px 16px 24px;
  height: calc(76px - 32px - 16px);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
